import * as React from 'react'

import { Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import { useUnsafeCallback } from 'modules/core/hooks/useCallback'

type AltTooltipProps = {
  disabled?: boolean
} & Omit<React.ComponentProps<typeof Tooltip.Alt>, 'open' | 'toggle'>

const AltTooltip = ({ disabled = false, ...props }: AltTooltipProps) => {
  const [open, toggle] = useToggle(false)

  const handleToggle = useUnsafeCallback(
    (value: boolean) => {
      if (disabled) {
        return () => undefined
      }

      return toggle(value)
    },
    [disabled, toggle]
  )

  return <Tooltip.Alt open={!disabled && open} toggle={handleToggle} {...props} />
}

export default {
  Alt: AltTooltip,
}
